// @owners { team: patients }
import { createSelector } from 'reselect';
import getLoading from '~shared/features/ui/selectors/getLoading';
import { type ReduxStateShared } from '~shared/types';

export const getFetchQuantityOptionsLoading: (state: ReduxStateShared) => boolean = createSelector(
  getLoading,
  (loading) => loading?.fetchQuantityOptionsLoading,
);
